import { SpeciConsignmentStatus } from '@shared/components/speci/speci-types'

export const SPECI_CONSIGNMENT_STATUS_LABELS = {
  [SpeciConsignmentStatus.ConsignmentComplete]: 'Consignment complete, ok to proceed',
  [SpeciConsignmentStatus.ConsignmentNotCompleteHoldForBalance]:
    'Consignment not complete, hold for balance',
  [SpeciConsignmentStatus.ShearingNotCompleteSellQualifiedWool]:
    'Shearing not complete, sell wool that qualifies',
}

/**
 * Converts a consignment status value to its corresponding string label.
 *
 * @param consignmentStatus - The consignment status value to convert.
 * @returns The string label corresponding to the given consignment status value.
 */
export const consignmentStatusValueToString = (consignmentStatus: SpeciConsignmentStatus) =>
  SPECI_CONSIGNMENT_STATUS_LABELS[consignmentStatus]

/**
 * The SPECI_CONSIGNMENT_STATUS_LABELS object as a list of objects
 * with 'value' and 'label' attributes. Use for combo box options.
 */
export const SPECI_CONSIGNMENT_STATUS_COMBOBOX_OPTIONS = Object.entries(
  SPECI_CONSIGNMENT_STATUS_LABELS
).map(([value, label]) => ({
  value,
  label,
}))
